import { combineReducers } from "redux";
import auth from "./auth";
import message from "./message";
import location from "./location";
import search from "./search";

export default combineReducers({
  auth,
  message,
  location,
  search,
});
